import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import './ComingSoon.css';

export function ComingSoon() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { type, id } = useParams();

  // Determine what content to show based on route
  const getContent = () => {
    if (type === 'tablets' && id) {
      const tabletNames: Record<string, string> = {
        'danishcha-7': t('landing.tablets.d7.name', 'Danishcha 7'),
        'danishcha-8': t('landing.tablets.d8.name', 'Danishcha 8'),
        'danishcha-10': t('landing.tablets.d10.name', 'Danishcha 10'),
      };
      return {
        icon: '📱',
        title: tabletNames[id] || t('comingSoon.tablet', 'Tablet'),
        subtitle: t('comingSoon.tabletSubtitle', 'Product details coming soon'),
      };
    }
    return {
      icon: '🚀',
      title: t('comingSoon.title', 'Coming Soon'),
      subtitle: t('comingSoon.subtitle', 'We\'re working hard to bring you something amazing'),
    };
  };

  const content = getContent();

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-bg">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>
      
      <div className="coming-soon-content">
        <div className="coming-soon-icon-wrapper">
          <span className="coming-soon-icon">{content.icon}</span>
        </div>
        
        <h1 className="coming-soon-title">{content.title}</h1>
        <p className="coming-soon-subtitle">{content.subtitle}</p>
        
        <div className="coming-soon-features">
          <div className="feature-item">
            <span className="feature-icon">✨</span>
            <span>{t('comingSoon.feature1', 'Beautiful Design')}</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">⚡</span>
            <span>{t('comingSoon.feature2', 'Fast Performance')}</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🔒</span>
            <span>{t('comingSoon.feature3', 'Secure & Reliable')}</span>
          </div>
        </div>

        <div className="coming-soon-countdown">
          <div className="countdown-item">
            <span className="countdown-number">--</span>
            <span className="countdown-label">{t('comingSoon.days', 'Days')}</span>
          </div>
          <div className="countdown-separator">:</div>
          <div className="countdown-item">
            <span className="countdown-number">--</span>
            <span className="countdown-label">{t('comingSoon.hours', 'Hours')}</span>
          </div>
          <div className="countdown-separator">:</div>
          <div className="countdown-item">
            <span className="countdown-number">--</span>
            <span className="countdown-label">{t('comingSoon.minutes', 'Minutes')}</span>
          </div>
        </div>

        <div className="coming-soon-actions">
          <button 
            className="btn btn-primary btn-lg"
            onClick={() => navigate('/#waitlist')}
          >
            {t('comingSoon.notify', 'Notify Me')}
          </button>
          <button 
            className="btn btn-outline btn-lg"
            onClick={() => navigate(-1)}
          >
            {t('comingSoon.goBack', 'Go Back')}
          </button>
        </div>

        <p className="coming-soon-note">
          {t('comingSoon.note', 'Join our waitlist to be the first to know when we launch!')}
        </p>
      </div>
    </div>
  );
}
